import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import StudentExamCard from './StudentExamCard';
import AutomatedExamCard from './AutomatedExamCard';
import Drawer from '../Drawer/Drawer';
import { config } from '../../config.js';

const StudentDashboard = observer(class StudentDashboard extends React.Component {
  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      examSid: null,
      sessionSid: null,
      proctorLocationSid: null,
      confirmedDate: null,
      messageSid: null
    }

    this.getStudentExams();
    this.props.store.SessionStore.getCurrentTime();
    this.props.store.SettingsStore.getInstituteSettings();
  }

  getStudentExams() {
    const { StudentStore, ScheduleStore } = this.props.store;
    const { examSessionSid } = ScheduleStore;

    StudentStore.getOrderedStudentExams(true, examSessionSid);
  }

  renderResults() {
    const { store, translation } = this.props;
    const { StudentStore } = store;
    const { orderedExams } = StudentStore;
    const { active, upcoming, closed } = orderedExams;
    const examStatuses = ['active', 'upcoming', 'closed'];

    if(
      !orderedExams ||
      (active.length === 0 && upcoming.length === 0 && closed.length === 0)
    ) {
      return (
        <div className="no-results">
          {translation.no_results}
          <span className="no-results__sub">{translation.no_results_sub}</span>
        </div>
      )
    } else if (orderedExams) {
      return (
        <div className="wrap">
          {/* Render active, upcoming, and closed exams by looping through arrays */}
          {examStatuses.map(status => {
            if (orderedExams[status] && orderedExams[status].length > 0) {
              return (
                <section
                  className="page__section exam-section"
                  key={status}
                >
                  <h2 className="exam-section__heading">
                    {translation.exam_sections[status]}
                  </h2>

                  <ol className="exam-section__list">
                    {orderedExams[status].map((exam) => {
                      let { proctorGroups, schedulingModule } = exam.examSession;
                      let { proctorTypes } = exam.examSession.examConfiguration;
                      const status = exam.examSession.status.toLowerCase();

                      // We need to determine if this exam is automated-only.
                      // If it is, we can show a more streamlined exam card
                      // because scheduling doesn’t really matter.
                      let hasAutomated = false;
                      let hasUnautomated = false;
                      let isAutomatedOnly = false;
                      let scheduledElsewhere = false;
                      const isReconnect = status === 'pending reconnection';


                      if(proctorGroups) {
                        if(proctorGroups.length && proctorGroups[0].proctorGroups){
                          proctorGroups = proctorGroups[0].proctorGroups;
                        }
                        // Check if this session has anything other than
                        // automated proctor groups enabled
                        proctorGroups.forEach(proctorGroup => {
                          // leaving this as the individual proctor groups can also be returned nested in single item arrays
                          if(proctorGroup.workflowModule !== 'automated' && proctorGroup[0].workflowModule !== 'automated') {
                            hasUnautomated = true;
                          } else {
                            hasAutomated = true;
                          }
                        });
                      } else if(proctorTypes) {
                        // Check if any automated proctor types
                        // are enabled for this exam session
                        proctorTypes.forEach(type => {
                          if(config.automatedProctorTypeSids.indexOf(type) > -1) {
                            hasAutomated = true;
                          } else {
                            hasUnautomated = true;
                          }
                        });
                      }

                      if(hasAutomated && !hasUnautomated) {
                        isAutomatedOnly = true;
                      }

                      // We also need to check if the exam was already
                      // scheduled with another modality (which is an edge case)
                      if(status === 'scheduled' && schedulingModule && schedulingModule !== 'automated') {
                        scheduledElsewhere = true;
                      }

                      if(!isAutomatedOnly || scheduledElsewhere || isReconnect) {
                        return (
                          <li key={exam.sid}>
                            <StudentExamCard
                              {...this.props}
                              exam={exam}
                              toggleDrawer={toggleDrawer}
                              parent={this}
                              reschedule={true}
                              hasAutomated={hasAutomated}
                            />
                          </li>
                        )
                      } else {
                        return (
                          <li key={exam.sid}>
                            <AutomatedExamCard
                              {...this.props}
                              exam={exam}
                              toggleDrawer={toggleDrawer}
                              parent={this}
                            />
                          </li>
                        )
                      }
                    })}
                  </ol>
                </section>
              )
            }

            return null;
          })}
        </div>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const { SessionStore, StudentStore } = this.props.store;

    if(typeof SessionStore.courseData.instructor !== 'undefined') {
      return(
        <main tabIndex="-1" id="main-content" aria-labelledby="page-title" className="page">
          <header className="page__header">
            <div className="wrap">
              <h1 id="page-title" className="page__title">{translation.page_title}</h1>
            </div>
          </header>

          {!SessionStore.loading &&
            this.renderResults()
          }

          <Drawer
            content={this.state.drawerContent}
            isOpen={this.state.drawerOpen}
            parent={this}
            exam={this.state.exam}
            examSid={this.state.examSid}
            sessionSid={this.state.sessionSid}
            reschedule={true}
            callback={StudentStore.getOrderedStudentExams}
            toUserSid={SessionStore.courseData.instructor.sid}
            contextType="examSid"
            contextId={this.state.examSid}
            proctorLocationSid={this.state.proctorLocationSid}
            confirmedDate={this.state.confirmedDate}
            messageSid={this.state.messageSid}
            proctorGroupSid={this.state.proctorGroupSid}
            external={true}
            {...this.props}
          />
        </main>
      )
    }

    return null;
  }
})

export default translate('StudentDashboard')(StudentDashboard);


// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/StudentDashboard.js